import React, { useEffect, useState } from "react";
import NavHeader from "../nav/NavHeader";
import Sidenav from "../nav/Sidemenu";
import { Link } from "react-router-dom";
import preloadimg from "../../assets/img/preloader1.gif";
import NodataAvailable from "../../assets/img/NoDataAvailable.jpg";
import {
  FaAngleDown,
  FaAngleUp,
  FaInfoCircle,
  FaRegChartBar,
  FaThLarge,
} from "react-icons/fa";
import $ from "jquery";
import UserInfo from "../auth/Getusers";
import LandingKPIReport from "../pageLayouts/LandingKPIReport";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import { useAsync } from "../hooks/useAsync";
import { getreportsList } from "../services/FetchAPI";

import {
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
  useMsal,
} from "@azure/msal-react";
import Login from "../auth/Login";

const Home = () => {
  const [iconsD, setIconsD] = useState(true);
  const [iconsR, setIconsR] = useState(true);
  const [userRole, setUserRole] = useState();
  const [userGroup, setuserGroup] = useState();
  const [TitleLoad, setTitleLoad] = useState(true);

  const { instance, accounts } = useMsal();

  const logout = async () => {
    // Will redirect to MSAL to end the session then redirect back to the configured `postLogoutRedirectUri`
    try {
      // Sign out the user
      // await instance.logoutRedirect({
      //   postLogoutRedirectUri: `${process.env.REACT_APP_SSO_LOGOUT_REDIRECT_URL}`, // Replace with your redirect URI
      // });
      localStorage.clear();
      window.location.href = `${process.env.REACT_APP_SSO_LOGOUT_REDIRECT_URL}`;
    } catch (error) {
      console.error("Logout failed", error);
    }
  };

  // const passtoken = JSON.parse(localStorage.getItem("access-token-storage"))[
  //   "accessToken"
  // ];

  const passtoken = !localStorage.getItem("access-token-storage") || localStorage.getItem("access-token-storage") === null
  ? null
  : JSON.parse(localStorage.getItem("access-token-storage"))["accessToken"]

  // useEffect(() => {
  //   if (passtoken === undefined || passtoken === null) {
  //     logout();
  //   }
  // }, [passtoken]);

  const {
    loading,
    errorData,
    value: reportListData,
  } = useAsync(() => {
    if (passtoken === undefined) {
      return Promise.resolve([]); // or any default value you want to return in this case
    }
    return getreportsList(passtoken);
  }, [passtoken]);

  useEffect(() => {
    document.title = "Home";
  }, []);

  const baseUrl = `${process.env.REACT_APP_SERVER_URL}/aipd/userListByEmail`;

  const fetchVisuals = async () => {
    try {
      const response = await fetch(baseUrl, {
        headers: {
          "oidc-token": passtoken,
          Accept: "application/json",
        },
      });

      // console.log(response)

      if (response.ok) {
        const json = await response.json();
        setUserRole(json);
        setuserGroup(json?.userGroup);
        setTitleLoad(false);
      } else {
        setUserRole([]);
        console.log("Request failed");
        setTitleLoad(true);
      }
    } catch (err) {
      console.error("Error occurred", err);
    }
  };

  // console.log(PageAuth)

  const toggleDept = () => {
    setIconsD((prev) => !prev);
    $("#Dept_div_id").slideToggle(350);
  };

  const toggleReport = () => {
    setIconsR((prev) => !prev);
    $("#Report_div_id").slideToggle(350);
  };

  const getClientsData = reportListData?.data;

  // localStorage.setItem("userGroup", getClientsData?.userGroupId);
  localStorage.setItem("RLTYPE", getClientsData?.defaultRlType);

  return (
    <div>
      <AuthenticatedTemplate>
        <NavHeader
          rlTypeData={getClientsData?.rlType}
          defaulRLData={getClientsData?.defaultRlType}
        />
        <Sidenav />
        {getClientsData !== null && (
          <div style={{ position: "relative" }} id="main">
            {loading && (
              <div
                style={{
                  position: "fixed",
                  background: "rgba(0,0,0,0.8)",
                  width: "100%",
                  height: "100%",
                  top: "0",
                  left: "0",
                  right: "0",
                  bottom: "0",
                  display: "grid",
                  justifyContent: "center",
                  alignItems: "center",
                  color: "white",
                  zIndex: "99999",
                  justifyItems: "center",
                  alignContent: "center",
                }}
              >
                <img width={200} src={preloadimg} alt="Loading" />
                <span>Loading Home page, please wait...</span>
              </div>
            )}

            {!loading && getClientsData !== undefined && !errorData && (
              <>
                <div>
                  <UserInfo />

                  {/* <PushNotifications/> */}
                </div>

                <div style={{ paddingTop: "0rem" }}>
                  <div
                    style={{ alignItems: "center" }}
                    className="header_icons_btn"
                  >
                    <>
                      <h1
                        style={{ marginTop: "0px" }}
                        className="headerText headerTextReport"
                      >
                        {getClientsData?.userGroupName}
                        {/* {getClientsData?.userGroupId === 104 && (
                                <span style={{fontSize:"18px",fontWeight:"500"}} className="user_items_cls items_cls">
                                {getClientsData?.defaultRlType}
                          </span>
                         )} */}
                      </h1>
                    </>

                    <div
                      style={{ cursor: "pointer", paddingTop: "0px" }}
                      onClick={toggleDept}
                      className="headerText headerTextReport"
                    >
                      {iconsD ? (
                        <span>
                          <FaThLarge className="toogleIconsClass" />
                          <FaAngleDown className="toogleIconsClass" />
                        </span>
                      ) : (
                        <span>
                          <FaThLarge className="toogleIconsClass" />
                          <FaAngleUp className="toogleIconsClass" />
                        </span>
                      )}
                    </div>
                  </div>

                  <div id="Dept_div_id">
                    <LandingKPIReport
                      rlType={getClientsData?.rlType}
                      defaultRL={getClientsData?.defaultRlType}
                    />
                  </div>

                  {iconsD ? (
                    <span></span>
                  ) : (
                    <span>
                      Please Toggle the Right icons for view all the Dashboard
                    </span>
                  )}
                </div>

                <div style={{ paddingBottom: "4rem" }} className="report">
                  <div className="header_icons_btn">
                    <h1 className="headerText headerTextReport">Reports</h1>
                    <div
                      style={{ cursor: "pointer" }}
                      onClick={toggleReport}
                      className="headerText headerTextReport"
                    >
                      {iconsR ? (
                        <span>
                          <FaThLarge className="toogleIconsClass" />
                          <FaAngleDown className="toogleIconsClass" />
                        </span>
                      ) : (
                        <span>
                          <FaThLarge className="toogleIconsClass" />
                          <FaAngleUp className="toogleIconsClass" />
                        </span>
                      )}
                    </div>
                  </div>
                  <div id="Report_div_id" className="dept-items">
                    {getClientsData?.reports.map((items, index) => {
                      return (
                        <Link
                          key={index}
                          to={
                            items[0] === 118
                              ? `/LIMS/${items[0]}`
                              : `/reports/${items[0]}/view`
                          }
                          className="box_link_items"
                        >
                          <div className="box-items">
                            <div
                              style={{ position: "relative" }}
                              className="card-items"
                            >
                              <div className="card-box">
                                <div className="iconsDiv">
                                  <FaRegChartBar color="A70E13" fontSize={24} />
                                </div>
                                <div className="ContentDiv">
                                  <span className="ContentDivText">
                                    {items[1]}
                                  </span>
                                  <div
                                    style={{
                                      position: "absolute",
                                      right: 10,
                                      top: 10,
                                    }}
                                  >
                                    <div className="tooltip_home">
                                      <OverlayTrigger
                                        transition={false}
                                        overlay={
                                          <Tooltip id="tooltip">
                                            {items[4] === ""
                                              ? items[1]
                                              : items[4]}
                                          </Tooltip>
                                        }
                                      >
                                        <span
                                          style={{ transition: "none" }}
                                          className="d-inline-block"
                                        >
                                          <FaInfoCircle
                                            style={{
                                              opacity: "0.7",
                                              transition: "none",
                                            }}
                                            color="#A70E13"
                                          />
                                        </span>
                                      </OverlayTrigger>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </Link>
                      );
                    })}
                  </div>
                  {iconsR ? (
                    <span></span>
                  ) : (
                    <span>
                      Please Toggle the Right icons for Report to view all
                      Reports
                    </span>
                  )}
                </div>
              </>
            )}

            {!loading && getClientsData === undefined && !errorData && (
              <div
                style={{
                  display: "grid",
                  justifyContent: "center",
                  textAlign: "center",
                }}
              >
                <img
                  style={{ width: "400px" }}
                  src={NodataAvailable}
                  alt="Nodata"
                  className="NoDataHome"
                />
                <div style={{ fontSize: "24px" }}>
                  There is no data available
                </div>
              </div>
            )}

            {errorData && (
              <>
                <div>There is Some error, {errorData}</div>
                <div>Plase Try after sometime</div>
              </>
            )}
          </div>
        )}

        {getClientsData === null && (
          <div style={{ position: "relative" }} id="main">
            <div
              style={{
                display: "grid",
                justifyContent: "center",
                textAlign: "center",
                justifyItems: "center",
              }}
            >
              <img
                style={{ width: "400px" }}
                src={NodataAvailable}
                alt="Nodata"
                className="NoDataHome"
              />
              <div style={{ fontSize: "24px" }}>
                There is no report associated with this persona, Kindly reach
                out to the admin for further details and resolution.
              </div>
            </div>
     
          </div>
        )}
      </AuthenticatedTemplate>

      <UnauthenticatedTemplate>
        <Login />
      </UnauthenticatedTemplate>
    </div>
  );
};

export default Home;
